module.exports = __webpack_public_path__ + "media/img/pages/companies/uniluzern-5053c8d320a6e5c509e504c6fa9582e6.png";